"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // @ts-check

var _busbudRefunds = require("./busbud-refunds");

var _busbudRefunds2 = _interopRequireDefault(_busbudRefunds);

var _noRefunds = require("./no-refunds");

var _noRefunds2 = _interopRequireDefault(_noRefunds);

var _partnerCallRefunds = require("./partner-call-refunds");

var _partnerCallRefunds2 = _interopRequireDefault(_partnerCallRefunds);

var _partnerRefunds = require("./partner-refunds");

var _partnerRefunds2 = _interopRequireDefault(_partnerRefunds);

var _selfServeRefunds = require("./self-serve-refunds");

var _selfServeRefunds2 = _interopRequireDefault(_selfServeRefunds);

var _stationRefunds = require("./station-refunds");

var _stationRefunds2 = _interopRequireDefault(_stationRefunds);

var _timePeriod = require("../../v2/time-period");

var _timePeriod2 = _interopRequireDefault(_timePeriod);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {V2.RefundDataGrouping} policy_grouping
 * @param {string} locale
 * @returns {V2.RefundPolicy}
 */
function refundPolicy(policy_grouping, locale) {
  var types = {
    "no-refund": _noRefunds2.default,
    unspecified: _noRefunds2.default,
    external: _partnerRefunds2.default,
    "call-operator": _partnerCallRefunds2.default,
    station: _stationRefunds2.default,
    "self-serve": _selfServeRefunds2.default,
    support: _busbudRefunds2.default
  };
  var policy_group_info = types[policy_grouping.type](policy_grouping);
  var timeline = policy_grouping.policies.map(function (time_period) {
    return (0, _timePeriod2.default)(time_period, locale);
  });

  return _extends({}, policy_group_info, { timeline: timeline });
}

exports.default = refundPolicy;
module.exports = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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